const mauritransFR = {
  mau_nav_home: 'Accueil',
  mau_nav_compass: 'Compass Resources',
  mau_nav_services: 'Services',
  mau_nav_about: 'À Propos',
  mau_nav_contact: 'Contact',
  mau_nav_quote: 'Demander un Devis',

  mau_hero_badge: 'Une Entreprise GDSATLAS - Leader en Logistique',
  mau_hero_title: 'Votre Partenaire Logistique\nComplet en Afrique',
  mau_hero_subtitle: "Services maritimes complets • Transit international • Solutions de chaîne d'approvisionnement de bout en bout",
  mau_hero_cta1: 'Explorer Nos Services',
  mau_hero_cta2: 'Demander un Devis',
  mau_hero_stat1_label: 'Expéditions Annuelles',
  mau_hero_stat2_label: 'Catégories de Services',
  mau_hero_stat3: '24h/24',
  mau_hero_stat3_label: 'Opérations',
  mau_hero_stat4: '100%',
  mau_hero_stat4_label: 'Fiabilité',

  mau_about_tag: 'Qui Nous Sommes',
  mau_about_title: "Connecter l'Afrique aux\nRoutes Commerciales Mondiales",
  mau_about_p1: "Mauritrans Shipping est une société complète de logistique et de transport maritime, entièrement détenue par GDSATLAS. Nous fournissons des services maritimes de bout en bout, du transit, du dédouanement et des solutions de chaîne d'approvisionnement à travers l'Afrique et à l'international.",
  mau_about_p2: "Grâce à notre vaste réseau, notre infrastructure moderne et notre équipe expérimentée, nous garantissons un mouvement efficace des marchandises et la fiabilité de la chaîne d'approvisionnement pour les entreprises de toutes tailles. Des opérations portuaires à la livraison finale, nous gérons chaque aspect de vos besoins logistiques.",
  mau_about_stat1: '15+',
  mau_about_stat1_label: "Années d'Expérience",
  mau_about_stat2: '50+',
  mau_about_stat2_label: 'Partenaires Mondiaux',

  mau_svc_tag: 'Nos Services',
  mau_svc_title: 'Solutions Logistiques Complètes',
  mau_svc_subtitle: "Neuf services spécialisés couvrant tous les aspects de la logistique maritime et de la gestion de la chaîne d'approvisionnement",
  mau_svc1_title: "Services d'Agence Maritime",
  mau_svc1_desc: "Services complets d'agence portuaire incluant le dédouanement des navires, la documentation et la coordination avec les autorités portuaires pour assurer des opérations fluides.",
  mau_svc2_title: 'Représentation de Compagnies Maritimes',
  mau_svc2_desc: "Représentation professionnelle des compagnies maritimes internationales, gérant leurs intérêts et opérations dans les ports mauritaniens et les marchés régionaux.",
  mau_svc3_title: 'Services de Consignation',
  mau_svc3_desc: "Consignation complète des navires incluant les changements d'équipage, les provisions, la livraison de pièces de rechange, l'assistance médicale et toutes les exigences liées au navire.",
  mau_svc4_title: 'Manutention Portuaire',
  mau_svc4_desc: "Services experts de manutention des marchandises avec équipements modernes et personnel qualifié pour le chargement et déchargement efficaces des navires.",
  mau_svc5_title: 'Manutention à Terre',
  mau_svc5_desc: "Opérations professionnelles de fret côté terre incluant le tri, le stockage et la préparation pour le transport vers la destination finale.",
  mau_svc6_title: 'Transit International',
  mau_svc6_desc: "Services complets de transit maritime et aérien connectant l'Afrique aux marchés mondiaux avec des solutions logistiques fiables.",
  mau_svc7_title: 'Dédouanement',
  mau_svc7_desc: "Services experts de courtage en douane assurant un dédouanement rapide et conforme des importations et exportations dans tous les ports mauritaniens.",
  mau_svc8_title: 'Entreposage',
  mau_svc8_desc: "Installations de stockage sécurisées avec systèmes modernes de gestion d'inventaire pour les besoins de stockage de marchandises à court et long terme.",
  mau_svc9_title: 'Transport Terrestre',
  mau_svc9_desc: "Services de transport porte-à-porte fiables à travers la Mauritanie et les pays voisins avec une flotte moderne et des systèmes de suivi.",

  mau_why_tag: 'Pourquoi Choisir Mauritrans',
  mau_why_title: 'Votre Partenaire Logistique de Confiance',
  mau_why_subtitle: "Délivrer l'excellence par l'expertise, la fiabilité et une couverture de services complète",
  mau_why1_title: 'Opérations 24h/24',
  mau_why1_desc: 'Service en continu garantissant que vos marchandises se déplacent sans délai',
  mau_why2_title: 'Manutention Sécurisée',
  mau_why2_desc: "Mesures de sécurité avancées et couverture d'assurance pour votre tranquillité",
  mau_why3_title: 'Réseau Mondial',
  mau_why3_desc: "Partenariats étendus connectant l'Afrique aux marchés mondiaux",
  mau_why4_title: 'Support Expert',
  mau_why4_desc: 'Équipe dédiée fournissant des solutions logistiques personnalisées',
  mau_why5_title: 'Tarifs Compétitifs',
  mau_why5_desc: "Solutions rentables sans compromis sur la qualité",
  mau_why6_title: 'Emplacement Stratégique',
  mau_why6_desc: "Position privilégiée en Mauritanie pour les routes commerciales africaines",
  mau_why7_title: 'Suivi en Temps Réel',
  mau_why7_desc: 'Systèmes avancés pour une visibilité complète des expéditions',
  mau_why8_title: 'Expertise Réglementaire',
  mau_why8_desc: 'Conformité réglementaire totale et support au dédouanement',

  mau_clients_tag: 'Nos Clients',
  mau_clients_title: 'La Confiance des Leaders du Secteur',
  mau_clients_subtitle: "Les grandes entreprises mondiales font confiance à Mauritrans Shipping pour leurs besoins logistiques et maritimes en Afrique",
  mau_clients_note: 'Au service de',
  mau_clients_note2: 'et de nombreux autres leaders mondiaux',

  mau_cta_title: "Prêt à Expédier\nen Toute Confiance ?",
  mau_cta_subtitle: "Obtenez une solution logistique personnalisée adaptée aux besoins de votre entreprise.\nContactez notre équipe aujourd'hui pour une consultation et un devis gratuits.",
  mau_cta_btn1: 'Demander un Devis',
  mau_cta_btn2: 'WhatsApp',

  mau_contact_tag: 'Nous Contacter',
  mau_contact_title: 'Contacter Mauritrans Shipping',
  mau_contact_subtitle: 'Contactez-nous pour discuter de vos besoins logistiques et obtenir une solution personnalisée',
  mau_contact_addr_label: 'Adresse',
  mau_contact_phone_label: 'Téléphone',
  mau_contact_email_label: 'Email',
  mau_contact_parent_label: 'Société Mère',
  mau_contact_note: "Mauritrans Shipping est une filiale à part entière de GDSATLAS, fournissant des services logistiques et maritimes complets à travers l'Afrique.",
  mau_form_title: 'Demander un Devis',
  mau_form_company: "Nom de l'Entreprise",
  mau_form_company_ph: 'Nom de votre entreprise',
  mau_form_name: 'Nom',
  mau_form_name_ph: 'Votre nom',
  mau_form_email: 'Email',
  mau_form_email_ph: 'votre@email.com',
  mau_form_service: 'Service Requis',
  mau_form_service_ph: 'Sélectionner un service',
  mau_form_svc_opt1: "Services d'Agence Maritime",
  mau_form_svc_opt2: 'Transit International',
  mau_form_svc_opt3: 'Dédouanement',
  mau_form_svc_opt4: 'Entreposage',
  mau_form_svc_opt5: 'Transport Terrestre',
  mau_form_svc_opt6: 'Autres Services',
  mau_form_message: 'Message',
  mau_form_message_ph: 'Décrivez vos besoins logistiques',
  mau_form_submit: 'Envoyer la Demande',

  mau_footer_tagline: "Mauritrans Shipping - Votre Partenaire Logistique et Maritime Complet en Afrique",
  mau_footer_subsidiary: 'Filiale à part entière de GDSATLAS Holding',
  mau_footer_back: 'Retour à GDSATLAS Holding',
  mau_footer_links: 'Liens Rapides',
  mau_footer_services: 'Nos Services',
  mau_footer_about: 'À Propos',
  mau_footer_contact: 'Contact',
  mau_footer_group: 'Groupe GDSATLAS',
  mau_footer_copyright: '© 2025 Mauritrans Shipping. Une Entreprise GDSATLAS. Tous droits réservés.',
};

export default mauritransFR;
